<template>
  <div class="prescriber-signature">
    <v-overlay v-if="showPopup">
      <h2 class="text-primary-default text-xl font-bold my-2">Handtekening toevoegen</h2>
      <v-paragraph class="text-primary-default text-base my-2">
        Om uw account compleet te maken, hebben wij nog uw handtekening nodig. Deze kunt u hier eenmalig invoeren,
        daarna wordt hij automatisch ingevoerd als u gevraagd wordt iets te ondertekenen. Zet hieronder uw handtekening
        en klik op 'Handtekening opslaan'
      </v-paragraph>
      <div class="flex flex-row">
        <div class="w-1/3 content-center">
          <img src="@/static/img/mascot_signature.svg" class="w-40 h-40" />
        </div>
        <div class="w-2/3">
          <v-input-digital-signature
            @save-signature="saveSignature"
            @undo-signature="undoSignature"
            class="w-72 h-72"
          />
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import axios from 'axios';
import VInputDigitalSignature from '@/components/shared/form/simple/InputDigitalSignature';
import { useStore } from 'vuex';
import { ref, onMounted } from 'vue';

export default {
  name: 'VPrescriberSignature',
  components: {
    VInputDigitalSignature
  },
  setup() {
    const store = useStore();
    const setSignatureSaved = (value) => store.commit('prescriber/setSignatureSaved', value);
    const showPopup = ref(false);

    const saveSignature = (empty, data) => {
      data = data.substr(22, data.length);
      let formData = { PrescriberSignature: data };
      return axios
        .post('UserSignature/SaveUserSignature', formData, {
          headers: {
            Accept: 'application/pdf'
          }
        })
        .then(() => {
          setSignatureSaved(true);
          return true;
        });
    };

    onMounted(() => {
      axios.get('UserSignature/GetUserSignatureConfiguration').then((response) => {
        setSignatureSaved(!response.data.UserSignatureConfiguration.SignatureIsMissing);
        showPopup.value = response.data.UserSignatureConfiguration.SignatureIsMissing;
      });
    });

    return {
      showPopup,
      setSignatureSaved,
      saveSignature
    };
  }
};
</script>
